module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.headerTopText'))
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.headerTopSubText')))]), _vm._v(" "), _c('span', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.headerText'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.openVideoModal('presentation')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchVideo'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover",
    on: {
      "click": function($event) {
        _vm.openVideoModal('realExample')
      }
    }
  }, [_c('div', {
    staticClass: "btn orange",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_vm._v(_vm._s(_vm.$t('component.watchExampleVideo'))), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    },
    on: {
      "mouseover": _vm.showDropdown,
      "mouseleave": _vm.hideDropdown
    }
  }, [_c('div', {
    staticClass: "dropdown-btn orange"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchBooklet'))), _c('span'), _vm._v(" "), (_vm.isDropdownVisible) ? _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('ul', _vm._l((_vm.booklets), function(booklet) {
    return _c('li', {
      key: booklet.language,
      on: {
        "click": function($event) {
          _vm.downloadBooklet(booklet.language)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$t(booklet.translationKey)) + "\n              "), _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("download")])])
  }), 0)]) : _vm._e()])])]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "data-scroll-offset": "120",
      "href": "#top",
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('component.moreAboutUs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "top-text"
  }, [_c('p', {
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.whyOurSolutionText'))
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.whyOurSolution')))])]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText4')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "400"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionOneText5')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element left clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('farmsProducts.sectionTwoText1'))
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionTwoText4')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "element right clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeTitle')))])]), _vm._v(" "), _c('ul', [_c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText1')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText2')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "300"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText3')))])]), _vm._v(" "), _c('li', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.sectionThreeText4')))])])])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "bottom-last"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', {
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThis')))]), _vm._v(" "), _c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[0]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisOneText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[1]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisTwoText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[2]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "350"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisThreeText')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('Counter', {
    attrs: {
      "data": _vm.circleValues[3]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "450"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('farmsProducts.whyIShouldUseThisFourText')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-hover"
  }, [_c('router-link', {
    staticClass: "btn orange",
    attrs: {
      "to": "/products/farms/presentation",
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('component.watchPresentation'))), _c('span')])], 1)])]), _vm._v(" "), _c('footer-more-information', {
    attrs: {
      "modalpage": 'farms'
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image1.jpg')"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-right",
      "data-aos-delay": "150"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image2.jpg')"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line",
    attrs: {
      "data-aos": "zoom-in-left",
      "data-aos-delay": "150"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-left",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('figure', {
    staticClass: "hexagon-image resizable",
    staticStyle: {
      "background-image": "url('/static/img/product/image3.jpg')"
    },
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "hexTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "hexBottom"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }, [_c('span', [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-first orange-bg"
  }, [_c('div', {
    staticClass: "image-boxes inline-boxes"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-1.jpg",
      "alt": "team1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "150"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-2.jpg",
      "alt": "team2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-3.jpg",
      "alt": "team3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "250"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/product/image-box-4.jpg",
      "alt": "team4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c75ba84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FarmsProduct.vue
// module id = 288
// module chunks = 0